import { createSelector } from '@ngrx/store';

import { selectConsentState } from '../consent.state';

export const selectConsentRendering = createSelector(
  selectConsentState,
  (state) => state.rendering
);

export const selectConsentRenderingFields = createSelector(
  selectConsentRendering,
  (rendering) => rendering?.fields
);

export const selectConsentSaveTitle = createSelector(
  selectConsentRenderingFields,
  (fields) => fields?.SaveTitle?.value
);

export const selectConsentSaveDescription = createSelector(
  selectConsentRenderingFields,
  (fields) => fields?.SaveDescription?.value
);

export const selectConsentAreYouSureConsent = createSelector(
  selectConsentRenderingFields,
  (fields) => fields?.AreYouSureConsentType?.value
);

export const selectConsentAreYouSureFields = createSelector(
  selectConsentRenderingFields,
  (fields) => ({
    areYouSureTitle: fields?.AreYouSureTitle?.value,
    areYouSureDescription: fields?.AreYouSureDescription?.value,
    areYouSureCancelButtonText: fields?.AreYouSureCancelButtonText?.value,
    areYouSureApproveButtonText: fields?.AreYouSureApproveButtonText?.value,
  })
);
